<script setup>
import { ref } from 'vue';
import { DateTime } from 'luxon';
import { useDisplay } from 'vuetify';
import { useRouter } from 'vue-router';
import { useSettingsStore } from '@/stores/settings';

const { lgAndUp, smAndUp } = useDisplay();
const router = useRouter();
const timeout = -1;

const { service, registrationStartDate } = useSettingsStore();

const currentDate = DateTime.fromMillis(Date.now());
const registrationPending = currentDate <= registrationStartDate;
// const registrationEnded = currentDate > registrationEndDate;

const showInstanceLink = ref(service.showInstanceLink);

const goToRegisterAccount = () => {
  router.push({ name: 'register-account' });
};

const goToValidateAccount = () => {
  router.push({ name: 'validate-account' });
};

const goToRegisterCompany = () => {
  router.push({ name: 'register-issue' });
};
</script>
<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" lg="9" xl="8">
        <v-snackbar
          v-if="registrationPending"
          v-model="showInstanceLink"
          multi-line
          class="pa-5"
          location="top"
          dark
          color="teal"
          :timeout="timeout"
        >
          <span>Пријава за студентску картицу ће почети 13.11.2023 у 12:00 часова.</span>
          <template #actions>
            <v-btn variant="text" @click="showInstanceLink = false"><v-icon icon="mdi-close" /></v-btn>
          </template>
        </v-snackbar>
        <v-row align="center" justify="center" :class="{ 'padding-top-80': lgAndUp }">
          <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="7">
            <v-card rounded="0" fluid @click="goToRegisterAccount">
              <div class="d-flex flex-no-wrap justify-space-between py-2">
                <div>
                  <v-card-title class="text-wrap main-headline mb-2">{{ $t('account.registerAccount') }}</v-card-title>
                  <v-card-text class="sub-headline">{{ $t('account.registerAccountSubTitle') }}</v-card-text>
                </div>
                <v-avatar v-if="smAndUp" class="mt-5 mr-5" size="64" tile>
                  <v-icon size="64" color="sprimary">mdi-file-document-edit-outline</v-icon>
                </v-avatar>
              </div>
              <div class="pa-0 header-part" />
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="mb-5">
          <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="7">
            <v-card fluid rounded="0" @click="goToValidateAccount">
              <div class="d-flex flex-no-wrap justify-space-between py-2">
                <div>
                  <v-card-title class="text-wrap main-headline mb-2">{{ $t('account.validateAccount') }}</v-card-title>
                  <v-card-text class="sub-headline">{{ $t('account.validateAccountSubTitle') }}</v-card-text>
                </div>
                <v-avatar v-if="smAndUp" class="mt-5 mr-5" size="64">
                  <v-icon size="64" color="sprimary">mdi-checkbox-marked-circle-outline</v-icon>
                </v-avatar>
              </div>
              <div class="pa-0 header-part" />
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="7">
            <v-card
              rounded="0"
              fluid
              style="border: 2px solid #c8113f"
              color="pio-primary"
              @click="goToRegisterCompany"
            >
              <div class="d-flex flex-no-wrap justify-space-between py-2">
                <div>
                  <v-card-title class="text-wrap main-headline mb-4">{{ $t('issue.registerTitle') }}</v-card-title>
                  <v-card-text class="sub-headline">{{ $t('issue.registerDescription') }}</v-card-text>
                </div>
                <v-avatar v-if="smAndUp" class="mt-5 mr-5" size="64" tile>
                  <v-icon size="64" color="ssecondary">mdi-headset</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
